module.exports = __webpack_public_path__ + "static/media/22ESCWA21.6a38da9f.jpg";